// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_2AA_kXCG37Q-OhYKVfw5XK","spaceLeft":"_18c6RNFbHgGTwyWjlKb7vk","spaceBoth":"_2p-PlpBj0TRwlFCicOM6i6","spaceRight":"_224ilg9AmUS7AGpbVKLBK6","OasisFooter":"iTQMLXwel_hSe8zfjIVBx","MistBrowser":"_3peVP-LgNtZuJScC7duMtO","LinksSection":"_3E4JiQu9_rnH3xUDzcdccP","Heading":"_1avoNxI74WwpxZTLX0JAbF","Link":"_3kb_79oQ2WdlsNbyyIRD6Y"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisFooter.scss
// module id = 1066
// module chunks = 0